var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0078125 5.14844C-0.0078125 2.38281 1.89062 0.429688 4.42188 0.429688C5.86719 0.429688 7.05469 1.125 7.75 2.17188C8.46094 1.11719 9.63281 0.429688 11.0781 0.429688C13.6094 0.429688 15.5078 2.38281 15.5078 5.14844C15.5078 8.47656 12.7188 11.75 8.32031 14.5625C8.14844 14.6641 7.91406 14.7734 7.75 14.7734C7.58594 14.7734 7.35156 14.6641 7.1875 14.5625C2.78125 11.75 -0.0078125 8.47656 -0.0078125 5.14844ZM1.25 5.14844C1.25 8.05469 4.32031 11.1875 7.59375 13.3594C7.66406 13.4141 7.71875 13.4531 7.75 13.4531C7.78125 13.4531 7.83594 13.4141 7.91406 13.3594C11.1797 11.1875 14.25 8.05469 14.25 5.14844C14.25 3.07031 12.9062 1.6875 11.0938 1.6875C9.63281 1.6875 8.82031 2.61719 8.28125 3.38281C8.05469 3.6875 7.9375 3.78125 7.75 3.78125C7.5625 3.78125 7.42969 3.69531 7.21875 3.38281C6.71875 2.60156 5.875 1.6875 4.40625 1.6875C2.59375 1.6875 1.25 3.07031 1.25 5.14844Z",
    fill: "#8B8AAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.59c282f298db38afdcd788444eac2882.svg";
export { ForwardRef as ReactComponent };